<script>
import utils from '@/utils/common';
import agreementApi from '@/api/agreement';

import BaseText from '@/components/BaseText.vue';
import FileList from '@/components/FileList.vue';
import NotificationCountSingle from '@/components/base/NotificationCountSingle.vue';

export default {
  name: 'AgreementTile',
  components: { BaseText, FileList, NotificationCountSingle },
  props: {
    item: Object,
  },
  computed: {
    status() {
      switch (this.item.isAgreed) {
        case null:
          return 'created';
        case false:
          return 'rejected';
        case true:
          return 'confirmed';
        default:
          return '';
      }
    },
    contactName() {
      return this.item.externalContact?.name ?? 'Адресат';
    },
    statusName() {
      const variants = {
        created: 'Ожидает согласования',
        rejected: 'Отправлено на доработку',
        confirmed: 'Согласовано',
      };

      return variants[this.status];
    },
    statusIcon() {
      const variants = {
        created: 'edit-alt-3',
        rejected: 'close3',
        confirmed: 'check',
      };

      return variants[this.status];
    },
    createdAt() { return utils.convertDateToString(new Date(this.item.createdAt), 'short', true, false); },
    answeredAt() { return utils.convertDateToString(new Date(this.item.answeredAt), 'short', true, false); },
  },
  methods: {
    async cancel() {
      if (!await this.$confirm('Вы действительно хотите удалить согласование?')) return;

      await agreementApi.delete(this.item.id, true)
        .catch(e => {
          this.$alert(
            e.description === 'Files already uploaded'
              ? 'Невозможно удалить. Внешний контакт уже загрузил файлы'
              : 'Неизвестная ошибка. Обратитесь в техподдержку'
          )
        });
      this.$emit('deleted');
    },
    copyLink() {
      const { extId, hash } = this.item;
      const { origin } = document.location;
      const url = `${origin}/ext/agreement/${extId}/${hash}`;
      navigator.clipboard.writeText(url);
      this.$push({ text: 'Ссылка скопирована в буфер обмена' });
    },
  },
};
</script>

<template lang="pug">
.b-agreement-tile
  ._header(:class="[status]")
    ._contact-name {{ contactName }}
      NotificationCountSingle(:query="{ agreementId: item.id }")._notification-count
    ._status(:class="[status]") {{ statusName }}
      Icon(:name="statusIcon" colored)
    ._date
      template(v-if="item.answeredAt") ответ {{ answeredAt }}
    ._date создано {{ createdAt }}
  BaseText._text(v-if="item.answer" ) {{ item.answer }}
  ._files(v-if="$slots.files")
    slot(name="files")
  ._buttons
    Btn(@click="cancel" sm grey v-if="status === 'created'") Отменить согласование
    Btn(@click="copyLink" sm) Копировать ссылку
</template>

<style scoped lang="scss">
.agreement-tile {
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 22px;

  &__header {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4px;

    & > :nth-child(even) {
      align-self: end;
      text-align: right;
    }
  }

  &__contact-name {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #33A1FB;
    position: relative;
  }

  &__notification-count {
    position: absolute;
    left: -43px;
    top: 50%;
    z-index: 1;
    translate: 0 -50%;
  }

  &__date {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__buttons {
    display: flex;
    gap: 16px;
    flex-shrink: 0;
  }

  &__status {
    font-size: 14px;
    font-weight: 500;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 6px;

    &.created {
      color: #FFB27B;
    }

    &.rejected {
      color: #F17275;
    }

    &.confirmed {
      color: #6CD796;
    }
  }

  &__text {
    padding: 0;
    background: #F5F7F9;
  }

  @media (max-width: 800px) {
    &__buttons {
      order: 3;
    }

  }

  @media (max-width: 576.98px) {
    &__notification-count {
      left: -26px;
    }
  }
  @media (max-width: 500px) {
    &__buttons {
      flex-direction: column;
      width: 100%;
    }

    &__header {
      grid-template-columns: 1fr;

      & > :nth-child(even) {
        align-self: start;
        text-align: left;
      }

      & > :nth-child(4) {
        grid-row: 2;
        margin-bottom: 10px;
      }
    }

    &__status {
      flex-direction: row;
    }
  }
}
</style>
